// Global fetch interceptor: attach the JWT Bearer token to same-origin /api/
// requests and bounce to /login on 401. Pages use raw fetch(), so patching
// window.fetch here authenticates them all without touching each call site.

const originalFetch = window.fetch.bind(window);

function isApiRequest(input: RequestInfo | URL): boolean {
  const url = typeof input === 'string' ? input : input instanceof URL ? input.href : input.url;
  return url.includes('/api/');
}

window.fetch = async (input: RequestInfo | URL, init: RequestInit = {}) => {
  if (isApiRequest(input)) {
    const token = localStorage.getItem('access_token');
    if (token) {
      const headers = new Headers(init.headers || {});
      if (!headers.has('Authorization')) headers.set('Authorization', `Bearer ${token}`);
      init = { ...init, headers };
    }
  }

  const res = await originalFetch(input, init);

  if (res.status === 401 && isApiRequest(input) && !String(
    typeof input === 'string' ? input : (input as Request).url || '').includes('/auth/login')) {
    localStorage.removeItem('access_token');
    if (!window.location.pathname.startsWith('/admin')) {
      if (window.location.pathname !== '/login') window.location.href = '/login';
    } else if (window.location.pathname !== '/admin/login') {
      window.location.href = '/admin/login';
    }
  }
  return res;
};

export {};
